<template>
  <div class="empty-block d-flex grow-1 flex-column align-items-center justify-content-center">
    <div v-html="illustration" />
    <p class="paragraph-14-regular text-black4 mt-2 text-center">
      {{ message }}<br />
      Please try another keyword
    </p>
  </div>
</template>

<script>
import { svg } from '@/app/editor/sidebar/utils/actions.assets';

export default {
  props: {
    fill: {
      type: String,
      default: '#9E9E9E',
    },
    message: String,
  },
  computed: {
    illustration() {
      return svg('noItemFound');
    },
  },
};
</script>

<style lang="scss" scoped></style>
